import {
  CUSTOM_ELEMENTS_SCHEMA,
  isDevMode,
  NgModule,
  NO_ERRORS_SCHEMA,
} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MaterialModule } from './shared/modules/material/material-module.module';

import { AngularSignaturePadModule } from '@almothafar/angular-signature-pad';

import { HttpClient } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { register } from 'swiper/element/bundle';

register();

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import {
  DefaultDataServiceConfig,
  EntityDataModule,
  HttpUrlGenerator,
} from '@ngrx/data';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

import { entityConfig } from './entity-metadata';

import { registerLocaleData } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import localePt from '@angular/common/locales/pt';
import { AngularToastifyModule, ToastService } from 'angular-toastify';
import { AppHttpUrlGenerator } from './core/services/httpUrlGenerator.service';
import { ClientModule } from './modules/client/client.module';
import { DesignSampleModule } from './modules/design-sample/design-sample.module';
import { RootModule } from './modules/root/root.module';
import { QuestionnaireAnswerComponent } from './shared/components/examples/questionnaire-answer/questionnaire-answer.component';
import { ThemedPipe } from './shared/pipes/themed.pipe';
registerLocaleData(localePt);

@NgModule({
  declarations: [AppComponent, QuestionnaireAnswerComponent],
  imports: [
    AngularToastifyModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MaterialModule,
    HttpClientModule,
    AngularSignaturePadModule,
    MatDatepickerModule,
    MatNativeDateModule,
    FormsModule,
    ReactiveFormsModule,
    MatSnackBarModule,
    MatTooltipModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    MatSnackBarModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    MatTooltipModule,
    HttpClientModule,
    StoreModule.forRoot({}, {}),
    EffectsModule.forRoot([]),
    EntityDataModule.forRoot(entityConfig),
    StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: !isDevMode() }),
    MatDialogModule,
    HttpClientModule,
    ClientModule,
    DesignSampleModule,
    RootModule,
    ThemedPipe,
  ],
  providers: [
    ToastService,
    MatDatepickerModule,
    MatNativeDateModule,
    { provide: MAT_DIALOG_DATA, useValue: {} },
    { provide: MatDialogRef, useValue: {} },
    HttpClientModule,
    { provide: HttpUrlGenerator, useClass: AppHttpUrlGenerator },
    { provide: DefaultDataServiceConfig, useValue: DefaultDataServiceConfig },
    HttpClient,
  ],
  bootstrap: [AppComponent],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
